import { render } from "./App.vue?vue&type=template&id=05479916"
const script = {}
script.render = render

export default script